import {
  Box,
  Button,
  Card,
  CircularProgress,
  Grid,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import ExchangeCompletedImageBuyer from 'assets/images/ExchangeCompletedImageBuyer.png';
import { postApiCall } from 'api/apiService';
import {
  POST_BUYER_BANNER_CLOSE,
  POST_BUYER_BANNER_VIEW,
} from 'constant/app.config';

const ExchangeCompletedBannerBuyer = (props) => {
  const {
    isBuyerDashboard,
    buyerDashboardDetails,
    getBuyerIndividualValue,
    groupIt,
    DashboardGroupCall,
    pauseBuyerExchangeBanner,
    setExchangeCompleteClose,
  } = props;
  const theme = useTheme();

  const matchesmd = useMediaQuery(theme.breakpoints.down('md'));
  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));
  const matches450 = useMediaQuery(theme.breakpoints.down(450));

  const PropertyId = isBuyerDashboard
    ? buyerDashboardDetails?.property?.propertyId
    : getBuyerIndividualValue?.PropertyDetails?.property?.propertyId;

  const isBannerviewCompleted = isBuyerDashboard
    ? buyerDashboardDetails?.isExchangedCloseViewed == 0
    : getBuyerIndividualValue?.PropertyDetails?.isExchangedCloseViewed == 0;

  let input = {
    propertyId: PropertyId,
    isViewed: 1,
    bannerCode: 'BUYER005',
    bannerHeading: 'Exchange complete buyer banner',
  };

  useEffect(() => {
    if (pauseBuyerExchangeBanner && isBannerviewCompleted) {
      postApiCall(POST_BUYER_BANNER_VIEW, input);
      if (!isBuyerDashboard) {
        groupIt();
      }
      if (isBuyerDashboard) {
        DashboardGroupCall();
      }
    }
  }, [pauseBuyerExchangeBanner, isBannerviewCompleted]);

  const [closeLoader, setCloseLoader] = useState(false);
  const handleBuyerExchangeCompleteCloseApiCall = async () => {
    let input = {
      propertyId: PropertyId,
      bannerCode: 'BUYER005',
      bannerHeading: 'Exchange complete buyer banner',
    };

    try {
      setCloseLoader(true);

      const response = await postApiCall(POST_BUYER_BANNER_CLOSE, input);

      if (response?.data?.status == 1) {
        setExchangeCompleteClose((prev) =>
          prev.includes(PropertyId) ? prev : [...prev, PropertyId]
        );
        if (!isBuyerDashboard) {
          groupIt();
        }
        if (isBuyerDashboard) {
          DashboardGroupCall();
        }
      } else {
        console.error('API call unsuccessful:', response);
      }
    } catch (error) {
      console.error('API call failed:', error);
    } finally {
      setCloseLoader(false);
    }
  };

  return (
    <>
      <Grid
        container
        sx={{
          scrollbarWidth: 'none',
          background: 'white',
          margin: '0 auto',
          zIndex: 1,
        }}
      >
        <Card
          variant="outlined"
          sx={{
            background: 'rgba(33, 132, 253, 0.8)',
            width: '100%',
            borderRadius: '20px',
            p: matchessm ? 1 : 2,
            display: 'flex',
            flexDirection: 'row',
            height: matchessm ? 390 : matchesmd ? 330 : 300,
          }}
        >
          <Grid container alignItems={'center'}>
            <Grid item xs={12} md={9} display="flex" alignItems="center">
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'start',
                  width: '100%',
                  px: matchessm ? 1.5 : 3,
                  gap: matchessm ? 1.5 : 0.6,
                }}
              >
                <Typography
                  sx={{
                    color: '#FFF',
                    fontWeight: 300,
                    fontSize: matchessm ? '14px' : '16px',
                    fontFamily: 'poppins',
                    textDecoration: 'none',
                    marginTop: matchessm ? '-20px' : '-10px',
                  }}
                >
                  {getBuyerIndividualValue?.PropertyDetails?.propertyAddress
                    ?.streetName ||
                    buyerDashboardDetails?.propertyAddress?.streetName}
                </Typography>

                <Typography
                  sx={{
                    fontSize: !matches450 ? '32px' : '18px',
                    fontWeight: 600,
                    color: '#FFF',
                    fontFamily: 'poppins',
                    mt: 1,
                  }}
                >
                  Congratulations Exchange Completed
                </Typography>

                <Typography
                  sx={{
                    fontSize: matchessm ? '14px' : '16px',
                    fontFamily: 'poppins',
                    fontWeight: 300,
                    mt: 1.5,
                    color: '#FFF',
                  }}
                >
                  The Contract of Sale has been signed by all parties. Deposit
                  payment has been confirmed received. Exchange has been
                  confirmed as complete for{' '}
                  <Typography
                    component="span"
                    sx={{
                      color: '#FFF',
                      fontWeight: matchessm ? 400 : 700,
                      fontSize: matchessm ? '14px' : '16px',
                      fontFamily: 'poppins',
                      textTransform: 'capitalize',
                    }}
                  >
                    {getBuyerIndividualValue?.PropertyDetails?.propertyAddress
                      ?.streetName ||
                      buyerDashboardDetails?.propertyAddress?.streetName}
                    &nbsp;
                  </Typography>
                </Typography>

                <Stack
                  direction="row"
                  spacing={2}
                  mt={2.5}
                  alignItems="center"
                  flexWrap="wrap"
                  justifyContent={matchessm && 'space-between'}
                >
                  <Button
                    disabled={closeLoader}
                    onClick={handleBuyerExchangeCompleteCloseApiCall}
                    endIcon={closeLoader && <CircularProgress size="20px" />}
                    sx={{
                      px: 4,
                      height: matchessm ? 35 : 42,
                      borderRadius: '5px',
                      fontSize: matchessm ? '12px' : '14px',
                      textTransform: 'none',
                      border: '1px solid #E6F2FF',
                      backgroundColor: 'transparent',
                      color: '#E6F2FF',
                      fontFamily: 'poppins',
                      fontWeight: 300,
                      '&:hover': {
                        bgcolor: 'rgb(33, 132, 253)',
                        color: '#E6F2FF',
                      },
                    }}
                  >
                    Close
                  </Button>
                </Stack>
              </Box>
            </Grid>

            <Grid
              item
              xs={12}
              md={3}
              display={matchesmd ? 'none' : 'block'}
              textAlign="center"
            >
              <img
                src={ExchangeCompletedImageBuyer}
                alt="ExchangeCompletedImageBuyer"
                style={{ objectFit: 'contain', height: '265px' }}
              />
            </Grid>
          </Grid>
        </Card>
      </Grid>
    </>
  );
};

export default ExchangeCompletedBannerBuyer;
